import * as React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import landingImage from "./assets/img/Landing_Image.jpg";
import HeadBar from './HeadBar';
import { styled } from '@mui/material/styles';

export default function Start() {

  const LandingImg = styled('img')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '60%',
    },
    [theme.breakpoints.up('md')]: {
      width: '40%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '25%',
    },
  }));

  const Introduction = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      marginTop: '4%', //7
    },
    [theme.breakpoints.up('sm')]: {
      width: '60%',
      marginTop: '2%',
    },
    [theme.breakpoints.up('md')]: {
      width: '40%',
      marginTop: '2%', //4
    },
    [theme.breakpoints.up('lg')]: {
      width: '30%',
      marginTop: '1%',
    },
  }));

  const navigate = useNavigate();

  return (
    <div>
      <HeadBar />

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box marginY={1}></Box>

        <LandingImg src={landingImage} />
        <Introduction >
          <div style={{ fontSize: 16, textAlign: 'center', fontWeight: 'bold' }}>
            Sort Waste & Recyclables At Your Ground-level Resource Sorting Station
          </div>
          <div style={{ marginTop: '4%', fontSize: 13, textAlign: 'justify' }}>
            1. Waste chutes facilitate mindless throwing and disregard for
               environment we found that 17% of waste could be
               salvaged for recycling if sorted right.
          </div>
          <div style={{ marginTop: '2%', fontSize: 13, textAlign: 'justify' }}>
            2. Recycling chutes were found to be heavily contaminated
               with non recyclables or dirtied with food waste, resulting in
               very low or no recyclables collected.
          </div>
          <div style={{ marginTop: '2%', fontSize: 13, textAlign: 'justify' }}>
            3. Use the Resource Sorting Station to tackle the contamination
               problem and promote mindful resource sorting!
          </div>
        </Introduction>


        <Box marginTop={3}>
          <FormControl fullWidth>
            <Button
              style={{
                width: 300,
                height: 45,
                color: "black",
                backgroundColor: "#A7DB8C",
                borderColor: "#FF8C00",
                fontSize: 16,
              }}
              onClick={() => {
                navigate("/register",
                  // {
                  //   replace: true,
                  // }
                );
              }}
            >
              SIGN ME UP
            </Button>
          </FormControl>
        </Box>
      </Box>
    </div>
  );
}